import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(engineerId, email) {
  return yield oncallFetch("/api/oncall/partners/engineers/emails/remove", {
    engineerId,
    email,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/engineers/emails/remove.js